import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';

import { BaseWebService } from '../../../../shared/services/base-web.service';
import 'rxjs/add/observable/throw';

@Injectable()
export class FollowUpSmsService {
    constructor(
        private _baseWebService: BaseWebService
    ) { }

    getFollowUpTextData(data: any) {
        let section;
        switch (data['section']) {
            case 'follow-up':
                section = 'followup_communications';
                break;
            case 'non_start_tracking_followup':
                section = 'non_start_followup_communications';
                break;
            case 'parent_ortho_followup':
                section = 'parent_relapse_communications';
                break;
            case 'patient_ortho_followup':
                section = 'patient_relapse_communications';
                break;
            case 'patient_referral_followup':
                section = 'patient_referral';
                break;
            case 'virtual_consultation_followup':
                section = 'va/vc_followup';
                break;
        }
        const url = data?.fromSection === 'action_required_list'
            ? `v1/${section}/${data.communication_id}/contact/?type=text`
            : `v1/${section}/${data.id}/contact/?type=text`;

        return this._baseWebService.request(url, "get")
            .map((res: any) => res)
            .catch(this.handleError);
    }

    postTextMsg(data: any) {
        const url = `v1/action_required_list/`;
        const postData:any = {};
        postData.body = data;
        return this._baseWebService.request(url, "post", postData)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    handleError(error: Response | any) {
        return Observable.throw(error);
    }
}